import React, { createContext, useContext, useEffect, useState } from 'react';

const DEFAULTS = {
  facebookUrl: 'https://www.facebook.com/profile.php?id=61590111810532',
  facebookPageId: '61590111810532',
  instagramUrl: '',
  linkedinUrl: '',
  twitterUrl: '',
  youtubeUrl: '',
  fbPixelId: '',
  ogImageUrl: '',
  ogTitle: 'Löwenherz Invest AG — Schweizer Immobilieninvestments',
  ogDescription: 'Werden Sie Aktionär unserer Rendite-Immobilien in der Schweiz.',
};

const SocialContext = createContext({ social: DEFAULTS, loading: true, reload: () => {} });

const apiBase = () => (process.env.REACT_APP_BACKEND_URL || '').replace(/\/+$/, '');

export const SocialProvider = ({ children }) => {
  const [social, setSocial] = useState(DEFAULTS);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const r = await fetch(apiBase() + '/api/site/social');
      const data = await r.json();
      if (data?.success && data.social) {
        setSocial({ ...DEFAULTS, ...data.social });
      }
    } catch (_e) {
      // keep defaults
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <SocialContext.Provider value={{ social, loading, reload: load }}>
      {children}
    </SocialContext.Provider>
  );
};

export const useSocial = () => useContext(SocialContext);
